const EIGHT = 8;

// 转小写
const lower = value => value.toLowerCase();
// 转大写
const upper = value => value.toUpperCase();



let currencyStyle = (value, style) => { // 货币格式
  /**
   * style: 
   *   currency：货币
   *   number： 数字格式
   */
  if (style == 'number') { // 数字格式
    return parseFloat(value.replace(/[^\d\.-]/g, ""));
  } else { // 货币格式, 并保留2位小数
    var n = 2;
    value = parseFloat((value + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
    var l = value.split(".")[0].split("").reverse(),
      r = value.split(".")[1];
    var t = "";
    for (var i = 0; i < l.length; i++) {
      t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
    }
    return t.split("").reverse().join("") + "." + r;
  }
}



// /**
//  * 
//  * @param {*} value 
//  */
// let dataVroop = value => {   //全局方法 Vue.filter() 注册一个自定义解码过滤器,必须放在Vue实例化前面
//     let magvalue = decodeURIComponent(value).split("π");
//     let str = [];
//     // let vroop = "";
//     for (var i = 0; i < magvalue.length-1; i++) {
//       console.log(magvalue[i])
//       let one = (magvalue[i] * 2 ^ 6) - 10;
//       let two = one >> 8;
//       let item = two ^ 8;

//       console.log(item)
//       let asciiCode = parseInt(item,2);
//       console.log(asciiCode)
//       let charValue = String.fromCharCode(asciiCode);
//       str.push(charValue);
//     }
//     //  vroop = String.fromCharCode(parseInt(str,16));
//     // console.log(String.fromCharCode(parseInt("101100101111101",2 )))
//       return str.join("");
//     }



/**
 * //把字符串转成二进制运算π合并,再发起提交数据，交由后端处理
 * @param {*} value 
 */
let dataOOPvr = value => {
  let str = "";
  for (var i = 0; i < value.length; i++) {
    let one = value[i].charCodeAt().toString(2);
    let two = ++one * EIGHT;
    str += --two + "π"
  }
  let oopvr = encodeURI(str)
  console.log(oopvr)
  return oopvr;
}

let isNUll = value => {
  return value ? value : "未填写";
}

let vagueNumber = value => {
  return value ? value.replace(value.substr(4, 4), "****") : "存在风险，请设置";
}

// let  arrUnique = (arr, key) => {
//   let returnArr = [];
//   if (key) {
//     // 对象数组去重
//     const obj = {};
//     returnArr = arr.reduce((cur, next) => {
//       obj[next[key]] ? '' : obj[next[key]] = true && cur.push(next);
//       return cur;
//     }, []);
//     return returnArr;
//   }
//   // 普通数组去重
//   returnArr = arr.reduce((cur, next) => {
//     !cur.includes(next) && cur.push(next);
//     return cur;
//   }, []);
//   return returnArr;
// }

export { //抛出变量
  lower,
  upper,
  currencyStyle,
  // dataVroop,
  dataOOPvr,
  isNUll,
  vagueNumber,
}


// WEBPACK FOOTER //
// ./src/script/tools/filter.js